var path = '/app/components/dialogs/menu/menu.html';
var html = "<a class=btn-close ng-click=$ctrl.cancel()></a> <div class=custom-modal-wrap> <div class=custom-modal> <div class=\"modal-body flex-column center-xs middle-xs\" id=modal-body> <div class=row> <ul class=list-inline> <li> <a ng-click=$ctrl.toStages() class=btn-stages></a> </li> <li> <a ng-click=$ctrl.toHome() class=btn-home></a> </li> </ul> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/menu/menu.html
// module id = 205
// module chunks = 0